import { render, staticRenderFns } from "./CustomerSvcForm.vue?vue&type=template&id=05cc3f8d&scoped=true"
import script from "./CustomerSvcForm.vue?vue&type=script&lang=js"
export * from "./CustomerSvcForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerSvcForm.vue?vue&type=style&index=0&id=05cc3f8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cc3f8d",
  null
  
)

export default component.exports